// extracted by mini-css-extract-plugin
export default {"header-coupon":"HeaderCoupon_header-coupon__dfGA9"};